module.exports = __webpack_public_path__ + "img/protocol.59b00b99.png";